import React from 'react';
import { Col, Grid, Row } from 'antd';

import ImageC from 'src/components/Image';
import Contact from 'src/containers/TerapiRegeneratif/Contact';
import Hero from 'src/containers/TerapiRegeneratif/Hero';
import InformationPoint from 'src/containers/TerapiRegeneratif/InformationPoint';

const Secretome = () => {
	const { xl } = Grid.useBreakpoint();
	return (
		<div className="font-sans">
			<Hero
				title="Mengenal Secretome di Indonesia, Terapi Kesehatan Terbaik"
				description="Secretome di Indonesia menjadi terapi kesehatan yang mampu diandalkan sejak beberapa tahun terakhir. Secretome sendiri merupakan sekumpulan zat bioaktif yang dilepaskan oleh stem cell. Zat tersebut mengandung sejumlah besar protein seperti faktor pertumbuhan dan sitokin. Secretome juga mengandung makromolekul dan vesikel ekstrasel. Secretome memiliki peran penting dalam komunikasi antar sel pada berbagai proses fisiologi tubuh. Selain itu, secretome memiliki kemampuan untuk meregenerasi sel, memperbaiki jaringan yang rusak, menekan peradangan dan menjaga keseimbangan sistem imun. Yuk, pelajari lebih lanjut tentang Secretome di Indonesia!"
				image="/images/stem-cell/scientist.png"
				height="700px"
			/>

			<InformationPoint
				className="py-3 md:py-12"
				title="Fungsi dan Peran Secretome"
				point={[
					'Induksi Pembelahan Sel',
					'Percepatan regenerasi jaringan dan organ',
					'Bantu jaga keseimbangan sistem imun',
					'Anti-inflamasi atau menekan peradangan',
				]}
				image={['vitamin-skin-cells', 'molecule-inside', 'dna-closely', 'stem-cells-cellular']}
			/>

			<Contact
				className="py-3 xl:py-12"
				title="Cari tahu lebih <br> lanjut Secretome di Indonesia"
				image="/images/stem-cell/cell-scretome.png"
				contactUrl="https://api.whatsapp.com/send/?phone=6281188884321&text=Saya%20ingin%20mengetahui%20informasi%20lebih%20lanjut%20tentang%20secretome&type=phone_number&app_absent=0"
			/>

			<div className="bg-white py-12">
				<div className="container">
					<Row gutter={{ md: 30, xs: 0 }}>
						<Col xs={24} md={12}>
							<ImageC
								className="rounded-lg"
								width={xl ? 550 : 413}
								height={xl ? 275 : 207}
								src={'/images/stem-cell/molecule-atom.png'}
								style={{ objectFit: 'cover' }}
							/>
						</Col>
						<Col xs={24} md={12} className='space-y-2'>
							<h2 className="text-5xl font-bold max-xl:text-2xl max-xs:mt-4 max-xs:text-xl max-xs:font-semibold max-xs:leading-7">
								<span
									dangerouslySetInnerHTML={{
										__html: 'Pemanfaatan Secretome di Indonesia',
									}}
								/>
							</h2>
							<p className="text-xl max-xl:text-sm max-xs:leading-normal max-xs:text-neutral-5">
								<span
									dangerouslySetInnerHTML={{
										__html:
											// eslint-disable-next-line max-len
											'Dari beberapa penelitian dan uji klinis yang telah dan sedang berjalan, keberadaan Secretome di Indonesia memiliki beragam potensi untuk membantu beberapa indikasi seperti: <b>radang sendi, luka ulkus, autoimun, otot robek, peremajaan kulit hingga kebotakan</b>.',
									}}
								/>
							</p>
						</Col>
					</Row>
				</div>
			</div>
		</div>
	);
};

export default Secretome;
